<div class="mobile-menu-overlay"></div>
<ul class="lefty">
    <li ng-repeat="item in $ctrl.primaryMenuItems" class="ppp" ng-click="$ctrl.clickHandler($event, item)"><span ng-bind-html="item.text"></span></li>
</ul>
<ul>
    <li class="mobile-item" ng-click="$ctrl.clickHandler($event)">
        <div>...</div>
        <ul class="menu-more">
            <li ng-repeat="item in $ctrl.menuItems" ng-if="(item.divider && item.divText) || item.text"  ng-click="$ctrl.clickHandler($event, item)" ng-class="$ctrl.classes(item)">
                <span ng-if="item.divider && item.divText" class="divider-w-text">
                        <hr  />
                        <span ng-bind="item.divText"></span>
                        <hr  />
                </span>
                <span ng-if="item.text" ng-bind-html="item.text" class="menu-text"></span>
            </li>
        </ul>
    </li>
</ul>